import { render, staticRenderFns } from "./terminalcount.vue?vue&type=template&id=44245105&scoped=true"
import script from "./terminalcount.vue?vue&type=script&lang=js"
export * from "./terminalcount.vue?vue&type=script&lang=js"
import style0 from "./terminalcount.vue?vue&type=style&index=0&id=44245105&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44245105",
  null
  
)

export default component.exports